<ng-template #entityEditTemplate let-title="title">
  <app-devices-device-edit #editComponent
                                  (modelChange)="createModel$.next($event)"
                                  [creating]="true"
                                  [loading]="(loaded$ | async) === false"
                                  [model]="createModel$ | async"
                                  [readonly]="false"
                                  [stereotyped]="false"
                                  [title]="title">
  </app-devices-device-edit>
</ng-template>


<app-static-toast (closeToast)="onCloseChallenge($event)"
                         [toastListSubject]="challengeToastsSubject">
</app-static-toast>

<app-entity-overview #overviewComponent
                            [entityEditTemplate]="entityEditTemplate"
                            [entityOverviewBaseComponent]="this"
                            [stereotyped]="false"
                            detailLink="/devices"
                            module="management">
</app-entity-overview>
